import Items from 'containers/product-catalog/items/Items';
import { selectIsActionsBlocked } from 'containers/app/appSlice';
import { useAppSelector } from 'hooks';
import { FC } from 'react';
import MerchantOrTeamBlockedInfo from 'components/merchant-or-team-blocked/MerchantOrTeamBlockedInfo';

const ItemsPage: FC = () => {
  const isActionsBlocked = useAppSelector(selectIsActionsBlocked);

  if (isActionsBlocked) {
    return <MerchantOrTeamBlockedInfo title="Items" />;
  }

  return <Items />;
};

export default ItemsPage;
